export const TEST_TUBE_GET_REQUEST = 'TEST_TUBE_GET_REQUEST';
export const TEST_TUBE_GET_SUCCESS = 'TEST_TUBE_GET_SUCCESS';
export const TEST_TUBE_GET_ERROR = 'TEST_TUBE_GET_ERROR';
export const TEST_TUBE_GET_BY_KEY_REQUEST = 'TEST_TUBE_GET_BY_KEY_REQUEST';
export const TEST_TUBE_GET_BY_KEY_SUCCESS = 'TEST_TUBE_GET_BY_KEY_SUCCESS';
export const TEST_TUBE_GET_BY_KEY_ERROR = 'TEST_TUBE_GET_BY_KEY_ERROR';
export const TEST_TUBE_ADD_REQUEST = 'TEST_TUBE_ADD_REQUEST';
export const TEST_TUBE_ADD_SUCCESS = 'TEST_TUBE_ADD_SUCCESS';
export const TEST_TUBE_ADD_ERROR = 'TEST_TUBE_ADD_ERROR';
export const TEST_TUBE_EDIT_REQUEST = 'TEST_TUBE_EDIT_REQUEST';
export const TEST_TUBE_EDIT_SUCCESS = 'TEST_TUBE_EDIT_SUCCESS';
export const TEST_TUBE_EDIT_ERROR = 'TEST_TUBE_EDIT_ERROR';
export const TEST_TUBE_DELETE_REQUEST = 'TEST_TUBE_DELETE_REQUEST';
export const TEST_TUBE_DELETE_SUCCESS = 'TEST_TUBE_DELETE_SUCCESS';
export const TEST_TUBE_DELETE_ERROR = 'TEST_TUBE_DELETE_ERROR';
